import { CSSProperties } from 'react';

const getHoverStyle = (backgroundColor: CSSProperties['color']) => ({
  position: 'relative',
  zIndex: 0,
  backgroundColor,
});

export default getHoverStyle;
